import { render, staticRenderFns } from "./AddEditRfidToRider.vue?vue&type=template&id=da04ab16"
import script from "./AddEditRfidToRider.vue?vue&type=script&lang=js"
export * from "./AddEditRfidToRider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports